var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJardinerGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "26px",
    viewBox: "0 0 25 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "67B1B903-D9ED-4F8F-839F-97F196F08559") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V1-hp-jardiner",
    transform: "translate(-270.000000, -944.000000)",
    fill: "#9EA718",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MENU-Copy-4",
    transform: "translate(0.000000, 921.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(95.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jardinage-(2)",
    transform: "translate(175.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.74713626,6.80991444 L8.57684883,6.80991444 L8.57684883,17.4583072 C9.0733325,17.421973 9.58798325,17.4523345 10.0700328,17.5449119 L10.0700328,11.6786897 L10.8997454,11.6786897 C13.3739513,11.6786897 15.3867633,9.66587768 15.3867633,7.19167181 L15.3867633,4.86877526 C13.3673315,4.91028577 11.700092,4.54933343 10.0700328,6.01603829 C10.0700328,5.88543446 10.0700328,4.34541427 10.0700328,4.27150166 L10.0645578,4.27150166 C9.95207128,1.89684139 7.98505024,0 5.58301493,0 L3.26011837,0 L3.26011837,2.32289656 C3.26011837,4.79710243 5.27293039,6.80991444 7.74713626,6.80991444 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1531999,17.700203 L17.5897074,14.3539777 C16.4683262,14.1543887 15.2702949,14.4868711 14.4062391,15.3509269 L11.659776,18.0973899 C12.8976256,18.7434409 13.8851179,19.8304788 14.391805,21.1803171 C15.6330391,21.1233771 16.7854785,21.4137018 17.7524644,22.1976732 L19.5024761,20.4476615 C20.3665319,19.583108 20.6990142,18.3850767 20.499923,17.2636955 L17.1531999,17.700203 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0813982,14.4619847 C19.040684,14.7718203 18.9267043,15.6468261 18.8847956,15.9686073 C19.2110563,15.9261013 20.0778994,15.8132166 20.391916,15.7720047 C20.5280944,15.6357268 20.8564953,15.3077241 20.9961578,15.1682607 L19.68564,13.8577429 L19.0813982,14.4619847 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7306109,10.122792 C24.3694097,9.76183964 23.7812446,9.76159078 23.4200931,10.122792 C23.4200931,10.122792 20.741321,12.8020618 20.741321,12.8020618 L22.0518389,14.1125796 L24.7306109,11.4333098 C25.0899208,11.0880857 25.0896719,10.467817 24.7306109,10.122792 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2388091,23.7670095 C16.6444224,23.0760635 15.7699641,22.6708632 14.8497148,22.6735011 C14.5712359,22.6734016 13.5665222,22.6735509 13.271917,22.6735011 C12.3133427,17.6932348 5.67290461,17.6957732 4.71497731,22.6735011 L3.13767729,22.6735011 C1.51707493,22.6735011 0.177688895,23.9008984 0,25.4747143 L17.987392,25.4747143 C17.9165156,24.8406088 17.6565522,24.2475659 17.2388091,23.7670095 L17.2388091,23.7670095 Z",
    id: "Path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJardinerGreen);
export default __webpack_public_path__ + "static/media/jardiner-green.23e14e46320a78ce8c67ccfce46f53d9.svg";
export { ForwardRef as ReactComponent };